// Draw once on navigation, then keep the selected objects in React state.
export const selectImages = (images, count, key, storage = typeof sessionStorage === 'undefined' ? null : sessionStorage) => {
  const unique = [...new Map(images.map((image) => [image.id, image])).values()];
  const shuffled = [...unique];
  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  const selected = shuffled.slice(0, Math.min(count, shuffled.length));
  const signature = (list) => list.map((image) => image.id).sort().join('|');
  let previous;
  try { previous = storage?.getItem(key); } catch { /* Private browsing. */ }
  if (selected.length && signature(selected) === previous) {
    if (shuffled.length > selected.length) selected[selected.length - 1] = shuffled[selected.length];
    else if (selected.length > 1) selected.push(selected.shift());
  }
  try { storage?.setItem(key, signature(selected)); } catch { /* Optional history. */ }
  return selected;
};
